import { loadEdjsContent, createToc } from '@/js/components/loadEdjs';

const main = async () => {
    if(!document.querySelector('#page-article-show')) return;

    const id = document.querySelector('.post').getAttribute('data-id');
    const mode = document.querySelector('.post').getAttribute('data-mode');
    await loadEdjsContent(mode, id, 'body', '.body');

    createToc('.body');
    // ツイッターiframe表示の高さ合わせ
    $(".embed-container iframe[id^='tweet_']").on('load', function () {
        this.contentWindow.postMessage({ element: this.id, query: "height" }, "https://twitframe.com");
        $(this).parent().removeClass('embed-responsive-16by9')
    });

    $(window).bind("message", function (e) {
        let oe = e.originalEvent
        if (oe.origin != "https://twitframe.com")
            return;

        if (oe.data.height && oe.data.element.match(/^tweet_/))
            $("#" + oe.data.element).css("height", parseInt(oe.data.height) + "px");
    });

    $(".embed-container .instagram").parent().removeClass('embed-responsive-16by9')

}
export default main;
